import React from 'react'

// Stardust types `PageHeading.overline` as a string but renders it as children, and it drops `data-qa` on the back link itself.
export const backLabel = (text: string) =>
  ((<span data-qa="back-to-dashboard-link">{text}</span>) as unknown) as string
